import React from 'react';
import { Link } from 'react-router-dom';
import GolfIcon from './GolfIcon';
import '../styles/clubhouse.css';

export default function AuthLayout({ children, register = false }: { children: React.ReactNode; register?: boolean }) {
  return <main className="club-auth">
    <section className="club-auth-story">
      <Link to="/" className="club-logo"><GolfIcon name="flag"/><span>Fairplay<small>GOOD MATES. QUESTIONABLE GOLF.</small></span></Link>
      <img src="/images/fourball-banter-v2.webp" alt="Four buddies laughing together over a missed putt" />
      <div className="club-auth-story-copy"><p className="club-eyebrow">THE SATURDAY FOURBALL, UPGRADED</p><h2>Good mates.<br/>Bad shots.<br/><em>No more excuses.</em></h2><p>A little on the line. A lot to laugh about.</p></div>
    </section>
    <section className="club-auth-form">
      <div className="club-auth-heading"><p className="club-eyebrow">{register ? 'WELCOME TO THE FOURBALL' : 'BACK FOR ANOTHER ROUND'}</p><h1>{register ? 'Join the usual suspects.' : 'Your mates are waiting.'}</h1><p>{register ? 'Create your account. Bring your Handicap Index and your sense of humour.' : 'Sign in. There’s a score to settle.'}</p></div>
      {children}
      <div className="club-auth-features">{(['score','wallet','mates'] as const).map((name,i)=><div key={name}><GolfIcon name={name}/><span>{['Track scores','Friendly stakes','Play your mates'][i]}</span></div>)}</div>
      <p className="club-auth-fine">South African golf. Proper banter. 18+ · Bet responsibly.</p>
    </section>
  </main>;
}
